import { required } from 'vuelidate/lib/validators';
import InvStratObjective from '@/app/modules/toolkit/inv-strat/components/inv-strat-objective/inv-strat-objective.vue';
import InvStratAssets from '@/app/modules/toolkit/inv-strat/components/inv-strat-assets/inv-strat-assets.vue';
import InvStratBorrowing from '@/app/modules/toolkit/inv-strat/components/inv-strat-borrowing/inv-strat-borrowing.vue';
import InvStratDiversified from '@/app/modules/toolkit/inv-strat/components/inv-strat-diversified/inv-strat-diversified.vue';

export default {
  name: 'inv-strat-strategy',
  components: {
    InvStratObjective,
    InvStratAssets,
    InvStratBorrowing,
    InvStratDiversified,
  },
  data: () => ({
    error: false,
  }),
  computed: {
    invStrat() {
      return this.$store.getters['toolkit/getItemData'];
    },
    assets() {
      const { assets } = this.invStrat;
      if (assets.length > 0) {
        return assets.flatMap(asset => asset.name);
      }
      return [];
    },
    diversified() {
      return this.invStrat.diversified;
    },
  },
  methods: {
    handleNextStep() {
      if (this.diversified.diversified === 'yes') {
        this.$emit('hasDiversified');
      } else {
        this.$emit('nextStep');
      }
    },
    handleBackStep() {
      this.$emit('backStep');
    },
    handleDiversified(v) {
      if (v.$invalid) {
        this.error = true;
      } else {
        this.error = false;
      }
    },
  },
  validations: {
    assets: {
      required,
    },
  },
};
